module.exports = __webpack_public_path__ + "static/media/silos.f6beea76.png";